import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, useTheme } from '@mui/material';
import ShowModelLineageModal from '../../../components/ModelInventory/ModelRequest/ShowModelLineageModal';

const LinkedEntitiesCell = ({ value, row, entityType }) => {
  const theme = useTheme();
  const [lineageModalOpen, setLineageModalOpen] = useState(false);
  const [selectedLineageItem, setSelectedLineageItem] = useState(null);

  const handleLinkedEntitiesClick = useCallback(
    (rowItem) => {
      setSelectedLineageItem({
        item: { id: rowItem?.original?.unique_id },
        title: 'Linked Entities',
      });
      setLineageModalOpen(true);
    },
    [setSelectedLineageItem, setLineageModalOpen]
  );

  const handleCloseLineageModal = useCallback(() => {
    setLineageModalOpen(false);
  }, [setLineageModalOpen]);

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      handleLinkedEntitiesClick(row);
    },
    [handleLinkedEntitiesClick, row]
  );

  if (value === null || value === undefined) {
    return '-';
  }

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          cursor: 'pointer',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'fit-content',
            height: '20px',
            padding: '2px 12px',
            gap: '4px',
            borderRadius: '4px',
            border: '0.5px solid',
            borderColor: theme.palette.primary.main,
            backgroundColor:
              theme.palette.other?.topNavSelectionBg ||
              theme.palette.selection?.main,
            whiteSpace: 'nowrap',
            boxSizing: 'border-box',
          }}
        >
          <Typography
            component="span"
            variant="subtitle1"
            sx={{
              color: theme.palette.primary.main,
            }}
          >
            {value} Linked
          </Typography>
        </Box>
      </Box>
      {lineageModalOpen && (
        <ShowModelLineageModal
          open={lineageModalOpen}
          handleClose={handleCloseLineageModal}
          previewItem={selectedLineageItem}
          entityType={entityType}
          openInNewTab={true}
        />
      )}
    </>
  );
};

LinkedEntitiesCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  row: PropTypes.shape({
    original: PropTypes.shape({
      unique_id: PropTypes.string,
    }),
  }),
  entityType: PropTypes.string,
};

export default LinkedEntitiesCell;
